
import 'components/catalog.tag'
import 'pages/products/parameters/parameter-new-modal.tag'
riot.tag2('parameters-list', '  <div class="row">\n    <div class="col-md-3 hidden-xs hidden-sm">\n\n      <catalog-tree object="FeatureGroup" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" allselect="true" reload="true" descendants="true"></catalog-tree>\n    </div>\n    <div class="col-md-9 col-xs-12 col-sm-12">\n      <catalog object="Feature" cols="{cols}" search="true" sortable="true" reorder="true" handlers="{handlers}" allselect="true" reload="true" store="parameters-list" filters="{categoryFilters}" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(parameterOpen, &quot;products&quot;, &quot;1000&quot;)}">\n        <yield to="head">\n          <div class="dropdown" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 1}" style="display: inline-block;">\n            <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n            <ul class="dropdown-menu">\n              <li class="{disabled: selectedCount &lt; 2}" onclick="{handlers.merge}"><a href="#"><i class="fa fa-fw fa-pencil"></i> Объеденить параметры</a></li>\n            </ul>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="id" style="width: 5%;">{row.id}</datatable-cell>\n          <datatable-cell name="img" style="width: 50px;"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}" style="max-height: 32px;"></datatable-cell>\n          <datatable-cell name="name"><i class="fa {row.isActive ? &quot;fa-eye&quot; : &quot;fa-eye-slash text-noactive&quot;}"></i> {row.name}</datatable-cell>\n          <datatable-cell name="code">{row.code}</datatable-cell>\n          <datatable-cell name="measure">{row.measure}</datatable-cell>\n          <datatable-cell name="type">{handlers.featureName(row.type)}</datatable-cell>\n          <datatable-cell name="valCount">{row.valCount}</datatable-cell>\n          <datatable-cell name="nameGroup">{row.nameGroup}</datatable-cell>\n          <datatable-cell name="sort" style="width: 2%;">{row.sort}</datatable-cell>\n        </yield>\n      </catalog>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Feature';
self.categoryFilters = false;

var getFeaturesTypes = function getFeaturesTypes() {
    API.request({
        object: 'FeatureType',
        method: 'Fetch',
        data: {},
        success: function success(response) {
            self.featuresTypes = response.items;
            self.update();
        }
    });
};

var featureName = function featureName(type) {
    for (var i = 0; i < self.featuresTypes.length; i++) {
        if (self.featuresTypes[i].code === type) return self.featuresTypes[i].name;
    }
};

self.add = function () {
    modals.create('parameter-new-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            var params = { name: _this.name.value };
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'Feature',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        _this.modalHide();
                        if (response.id) riot.route('products/parameters/' + response.id);
                    }
                });
            }
        }
    });
};

self.parameterOpen = function (e) {
    return riot.route('/products/parameters/' + e.item.row.id);
};

self.cols = [{ name: 'id', value: '#' }, { name: 'img', value: 'Фото' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'Код (URL)' }, { name: 'measure', value: 'Ед. изм.' }, { name: 'type', value: 'Тип параметра' }, { name: 'valCount', value: 'Значений' }, { name: 'nameGroup', value: 'Группа параметра' }, { name: 'sort', value: 'Индекс' }];

self.handlers = {
    featureName: featureName,
    merge: setMerge
};

function setMerge(e) {
    var _this = this;
    var params = {};

    var items = _this.tags.datatable.getSelectedRows();
    var ids = items.map(function (item) {
        return item.id;
    });
    params = { ids: ids };
    params = _this.allParams(params);
    API.request({
        object: 'Feature',
        method: 'Merge',
        data: params,
        success: function success(response) {
            _this.reload();
        }
    });
}

self.one('updated', function () {
    self.tags['catalog-tree'].tags.treeview.on('nodeselect', function (node) {
        self.selectedCategory = node.__selected__ ? node.id : undefined;
        var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
        if (items.length > 0) {
            var value = items.map(function (i) {
                return i.id;
            }).join(',');
            self.categoryFilters = [{ field: 'idFeatureGroup', sign: 'IN', value: value }];
        } else {
            self.categoryFilters = false;
        }
        self.update();
        self.tags.catalog.reload();
    });
    self.tags.catalog.tags.datatable.on('reorder-end', function () {
        var _self$tags$catalog$pa = self.tags.catalog.pages,
            current = _self$tags$catalog$pa.current,
            limit = _self$tags$catalog$pa.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags.catalog.items.forEach(function (item, sort) {
            item.sort = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: 'Feature',
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });

        self.update();
    });
});

observable.on('parameters-groups-reload', function () {
    self.tags.catalog.reload();
});

getFeaturesTypes();
});


// WEBPACK FOOTER //
// ./pages/products/parameters/parameters-list.tag